import React from 'react';
import {
  ClearFiltersButton,
  IconWrapper,
  MessageContainer,
  MessageDescription,
  MessageTitle,
} from './ApiExplorerMessage.styles';

export interface ApiExplorerMessageProps {
  title: string;
  description: string;
  onClearFilters?: () => void;
  clearFiltersLabel?: string;
}

function NoResultsIcon() {
  return (
    <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3 6.08 3 3.28 5.64 3.03 9h2.02C5.3 6.75 7.18 5 9.5 5 11.99 5 14 7.01 14 9.5S11.99 14 9.5 14c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19z"
      />
      <path
        fill="currentColor"
        d="M6.47 10.82 4 13.29l-2.47-2.47-.71.71L3.29 14 .82 16.47l.71.71L4 14.71l2.47 2.47.71-.71L4.71 14l2.47-2.47z"
      />
    </svg>
  );
}

export function ApiExplorerMessage({
  title,
  description,
  onClearFilters,
  clearFiltersLabel = 'Clear All Filters',
}: ApiExplorerMessageProps) {
  return (
    <MessageContainer>
      <IconWrapper>
        <NoResultsIcon />
      </IconWrapper>
      <MessageTitle variant="h5">{title}</MessageTitle>
      <MessageDescription variant="body1">{description}</MessageDescription>
      {onClearFilters && (
        <ClearFiltersButton
          variant="contained"
          color="primary"
          disableElevation
          onClick={onClearFilters}
        >
          {clearFiltersLabel}
        </ClearFiltersButton>
      )}
    </MessageContainer>
  );
}
